import React from 'react';
import MixtureEncoder from './MixtureEncoder';
import ConfigurationEncoder from './ConfigurationEncoder';
import CapsuleEncoder from './CapsuleEncoder';
const Encoder = ({ type }) => {
    return (
        <>
            {type === 'mixture' && <MixtureEncoder />}
            {type === 'configuration' && <ConfigurationEncoder />}
            {type === 'capsule' && <CapsuleEncoder />}
            {!type ||( type !== 'mixture' && type !== 'configuration' && type !== 'capsule' )&& <div>Vous tentez d'encoder une mauvaise ressource.</div>}
        </>
    );
};

export default Encoder;
